module.exports = __webpack_public_path__ + "static/blog-top-743eace988a1dc212aeef9df82db554a.png";